import { jwtDecode } from "jwt-decode";
import { QUERY_STATUS } from "../constants/dataConstants";

const authService = {
  clearAuth() {
    authService.setNativeId(null);
    localStorage.removeItem("auth-accessToken");
    localStorage.removeItem("auth-nativeId");
    localStorage.removeItem("userAffiliateCode");
    localStorage.removeItem("userCountryCode");
    localStorage.removeItem("isAccessibleAPFeature");
    localStorage.removeItem("isAccessibleHATVFeature");
    localStorage.removeItem("isAccessibleReportBuilderFeature");
    localStorage.removeItem("isAccessibleConverseAIFeature");
    localStorage.removeItem("isAccessibleABOGrowthCompanion");
    localStorage.removeItem("currencyCode");
    localStorage.removeItem("isAccessibleAssignmentSection");
    sessionStorage.clear();
  },

  setNativeId(nativeId: any) {
    localStorage.setItem("auth-nativeId", nativeId);
  },

  decodeAccessToken(accessToken: any): any {
    return jwtDecode(accessToken);
  },

  handleTokenResponse(result: any) {
    let accessToken;
    if (result && result.head && result.head.authentication) {
      const auth = result.head.authentication;
      if (
        auth.loginSessionStatus === QUERY_STATUS.ACTIVE &&
        auth.userSessionStatus === QUERY_STATUS.ACTIVE &&
        result.body
      ) {
        accessToken = result.body;
      }
    }
    localStorage.setItem("auth-accessToken", accessToken);
    const decodedAccessToken: any = authService.decodeAccessToken(accessToken);
    if (decodedAccessToken) {
      authService.setNativeId(decodedAccessToken["NativeId"]);
    }
    return accessToken;
  },

  isAuthenticated() {
    const token = localStorage.getItem("auth-accessToken");
    if (token) {
      let decodedAccessToken = authService.decodeAccessToken(token);
      if (decodedAccessToken) {
        return !authService.isAuthorizationExpired(
          decodedAccessToken["LoginSessionExpiryTime"]
        );
      }
    }

    return false;
  },

  isAccessTokenApiUrl(url: string): boolean {
    return (
      !url.includes("/refresh/token") &&
      !url.includes("/refresh/session") &&
      !url.includes("/logout") &&
      !url.includes("/auth/authorize") &&
      !url.includes("/auth/token")
    );
  },

  isAccessTokenNeedsRefresh() {
    let isExpired = false;
    const token = localStorage.getItem("auth-accessToken");
    if (token) {
      let decodedAccessToken = authService.decodeAccessToken(token);
      if (decodedAccessToken) {
        //as long as session login token still active, refresh access token
        isExpired = authService.isAuthorizationRefresh(
          decodedAccessToken["UserSessionRefreshTime"],
          decodedAccessToken["LoginSessionRefreshTime"]
        );
      }
    }
    //console.log(`isAccessTokenNeedsRefresh isexpired: ${isExpired}`);
    return isExpired;
  },

  isSessionTokenNeedsRefresh() {
    let isExpired = false;
    const token = localStorage.getItem("auth-accessToken");
    if (token) {
      let decodedAccessToken = authService.decodeAccessToken(token);
      if (decodedAccessToken) {
        //as long as session login token still active, refresh access token
        isExpired = authService.isAuthorizationRefresh(
          decodedAccessToken["LoginSessionRefreshTime"],
          decodedAccessToken["LoginSessionExpiryTime"]
        );
      }
    }
    // console.log(`isSessionTokenNeedsRefresh isexpired: ${isExpired}`);
    return isExpired;
  },

  isAuthorizationRefresh(refresh: any, expiry: any) {
    if (
      refresh === null ||
      expiry === null ||
      refresh === "undefined" ||
      expiry === "undefined"
    ) {
      return false;
    }

    const currentUnix = new Date(new Date().toUTCString()).getTime();
    return currentUnix >= parseInt(refresh) && currentUnix <= parseInt(expiry);
  },

  isAuthorizationExpired(expiry: any) {
    if (expiry === null || expiry === "undefined") {
      return true;
    }

    const currentUnix = new Date(new Date().toUTCString()).getTime();
    return currentUnix > parseInt(expiry);
  },
};

export default authService;
